import React, {useState} from "react";
import Loading from "../Loading/Loading";
import {useEffectOnce} from "react-use";
import axios from "axios";
import {Provider, useDispatch} from "react-redux";
import store from '../../store/store';
import {setResults, setLabels, setConfiguration} from "../../store/slices/productFinder";
import simulateDelay from "../../helpers/simulateDelay";

import PageSwitch from "./PageSwitch/PageSwitch";
import Background from "./Background/Background";

const ProductFinder = (props) => {

    return (
        <Provider store={store}>
            <ProductFinderApp {...props} />
        </Provider>
    )

}

const ProductFinderApp = (props) => {
    const {
        configurationFile
    } = props;

    const dispatch = useDispatch();

    dispatch(setConfiguration({...props}));

    const [isConfigurationFileLoading, setIsConfigurationFileLoading] = useState(true);
    const [productFinderConfiguration, setProductFinderConfiguration] = useState(null);

    const fetchConfigurationFile = async function (url) {
        setIsConfigurationFileLoading(true);
        await simulateDelay();
        const response = await axios.get(url);
        setIsConfigurationFileLoading(false);
        setProductFinderConfiguration({...response.data});
        dispatch(setResults( response.data.results ));
        dispatch(setLabels( response.data.labels ));
    };

    useEffectOnce(()=> {
        fetchConfigurationFile(configurationFile);
    });

    if(isConfigurationFileLoading || !productFinderConfiguration) {
        return <Loading />;
    }

    return (
        <Provider store={store}>

            <div className="product-finder-wrapper">

                <Background />

                { (productFinderConfiguration.decisionTree) &&
                    <PageSwitch
                        pageData={productFinderConfiguration.decisionTree}
                    />
                }
            </div>

        </Provider>
    )


}

export default ProductFinder;

